import * as React from 'react';
import { Dialog, IconButton, Tooltip } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { useState } from "react";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import dayjs from "dayjs";
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import useCommonApi from '../../api/useCommonApi';
import { useSnackbar } from 'notistack';
import 'moment-timezone';
import moment from 'moment-timezone';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import { ApplicationState } from '../../redux/reducers';
import { connect } from "react-redux"
import { IFechaFestiva } from '../../entities/catalogos/IFechaFestiva';
import { useZonaHoraria } from '../../contextos/zonaHorariaContext';
import LoadingDialog from '../controls/LoadingDialog';

interface IDialogDateProps {
    value?: Date;
    abierto: boolean;
    minDate: string;
    onClose: () => void;
    onSave: (date: Date | null) => void;
    areaServicioRemitente: any
    cliente: any
    horarios?: any,
    aplicaReglasVentana: boolean,
    ventanaFijaParam?: any
}

interface StateProps {
    diasFestivos: IFechaFestiva[]
}

type Props = StateProps & IDialogDateProps

const PickUpDateRecoleccion = ({ value, onClose, onSave, areaServicioRemitente, cliente, horarios, aplicaReglasVentana, ventanaFijaParam, abierto, diasFestivos  }: Props) => {
    //const defaultDate = value ? dayjs(value) : dayjs();
    const defaultDate = value ? new Date(value) : new Date();
    const [selectedDate, setSelectedDate] = useState(defaultDate);
    const { enqueueSnackbar } = useSnackbar();
    const apiSource = useCommonApi();
    const [disabledGuardar, setDisabledGuardar] = useState(true);
    const { zonaHoraria, setZonaHoraria, fechaServidor, setFechaServidor } = useZonaHoraria();
    const [ventanaFija, setZonaVentanaFija] = useState({ horaInicio: { hours: 0, minutes: 0 }, horaFin: { hours: 0, minutes: 0 }, lun: 0, mar: 0, mie: 0, jue: 0, vie: 0 });
    let paramDay = localStorage.getItem("diasRad") === null ? "0" : localStorage.getItem("diasRad") as any;
    const [daysRad, setDaysRad] = useState(parseInt(paramDay));
    const [arrayDiasFestivos, setArrayDiasFestivos] = useState(new Array);
    const [showLoading, setLoading] = useState(false);
    const GMT_SERVER = -21600;

    React.useEffect(() => {
        if (areaServicioRemitente && areaServicioRemitente?.sucursal && (zonaHoraria.gmt === 0 || zonaHoraria.areaServicio !== areaServicioRemitente?.sucursal.id )) {
            getZonaHorariaServer().then(res => {
                if (res !== null) {
                    const fechaServidor = moment(
                        res,
                        'DD/MM/YYYY HH:mm:ss'
                    ).toDate();
                    setFechaServidor(fechaServidor);
                }
            });
            getZonaHoraria().then(res => {
                if (res !== null && res.zona !== '') {
                    setZonaHoraria({ zona: res.zona, gmt: res.gmt, areaServicio: areaServicioRemitente?.sucursal?.id });
                }
            });
        }
            if(arrayDiasFestivos.length === 0){
                getVentanaFija().then(res => {
                    setZonaVentanaFija({
                        horaInicio: { hours: res.horA_IN.hours, minutes: res.horA_IN.minutes },
                        horaFin: { hours: res.horA_FIN.hours, minutes: res.horA_FIN.minutes },
                        lun: res.lunes, mar: res.martes, mie: res.miercoles, jue: res.jueves, vie: res.viernes
                    });
                });

                getDiasInhabilProximos().then(res => {
                    let fecharArray = res.map(d => {
                    let [dia, mes, anio] = d.fecha.split('/');
                    let fechaFeriada = new Date(`${anio}-${mes}-${dia}T00:00:00`);
                    return fechaFeriada;
                });
                setArrayDiasFestivos(fecharArray);
            });
        }

    }, [value]);

    const WEEKDAYS_SHORT = {
        es: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        us: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    };

    const MONTHS = {
        es: [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre',
        ],
        us: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'Octuber',
            'November',
            'December',
        ]
    };

    const handleDateChange = (date: any, modifiers: any) => {

        if (modifiers.disabled) {
            return;
        }

        const diferenciaGMT = zonaHoraria.gmt - GMT_SERVER;
        let selectedDate = new Date(date).getDate();
         let actualDate = fechaServidor
                        ? new Date(
                                fechaServidor.getTime() +
                                (diferenciaGMT * 1000)
                            )
                        : new Date();
        let diaSemana = new Date(date).getDay();
        let options = zonaHoraria.zona.toString() != '' ? {timeZone: zonaHoraria.zona.toString()} : {};
        const esEntregaHoy = selectedDate == actualDate.getDate();
        let monthSelected = new Date(date).getMonth() + 1;
        let anioSelected = new Date(date).getFullYear();
        console.log(anioSelected);
        //valida los dias Rad
        let dateRad = new Date(Date.now()+daysRad*24*60*60*1000);
        let dateSelect = date;
        dateRad.setHours(0,0,0,0);
        dateSelect.setHours(0,0,0,0);

        if(dateSelect > dateRad){
            return;
        }

        let esFestivo = false;
        arrayDiasFestivos.forEach((dia) => {
            if(dateSelect.getTime() === dia.getTime()){
                esFestivo = true;
                return;
            }
        });
        if(esFestivo){
            return;
        }

        if(monthSelected == (actualDate.getMonth()+1))
        {
            if (selectedDate < actualDate.getDate()) {
                return;
            }
        }
        if(anioSelected < actualDate.getFullYear() || (anioSelected === actualDate.getFullYear() && monthSelected < (actualDate.getMonth()+1)))
        {
            return;
        }

        //Validar fecha y horarios solamente si hay área de servicio disponible
        if(areaServicioRemitente === undefined || areaServicioRemitente === null){
            setDisabledGuardar(false);
            setSelectedDate(date);
            return;
        }

         //SABADO - FUERA DE HORA CORTE SABADO
        if (esEntregaHoy && diaSemana === 6 && areaServicioRemitente.sucursal?.horaCorteSabado) {
            const horaCorteSab = new Date(
                actualDate.getFullYear(),
                Number(actualDate.getMonth() + 1),
                actualDate.getDate(),
                areaServicioRemitente.sucursal.horaCorteSabado.hours,
                areaServicioRemitente.sucursal.horaCorteSabado.minutes
            );
            if (actualDate > horaCorteSab) {
                enqueueSnackbar(traducirMessage(333), { variant: "error" });
                return;
            }
        }

        //Valida la ventana fija
        if (ventanaFija.horaInicio.hours > 0) {
            let horaCorte = new Date(actualDate.getFullYear(), Number(actualDate.getMonth() + 1), actualDate.getDate(), ventanaFija.horaInicio.hours, ventanaFija.horaInicio.minutes)
            //HORA CORTE SUCURSAL/ZONA HORARIA USUARIO
            if (esEntregaHoy && actualDate.getHours() >= horaCorte.getHours() && actualDate.getMinutes() > horaCorte.getMinutes()) {
                //let hf = `${ventanaFija.horaInicio.hours}:${ventanaFija.horaInicio.minutes != 0 ? ventanaFija.horaInicio.minutes : '00'}`;

                let error = traducirMessage(160).replace('#####', areaServicioRemitente.sucursal.nombre).replace('#####', Number(actualDate.getMonth() + 1) + "/" + actualDate.getFullYear());
                //`La sucursal ${areaServicioRemitente.sucursal.nombre} no permite la recolección en la fecha ${actualDate.getDate() + "/" + Number(actualDate.getMonth() + 1) + "/" + actualDate.getFullYear()} después de las ${hf}. Favor de revisar con el administrador.`
                enqueueSnackbar(error, { variant: "error" });
                return;
            }

            //RECOLECCION POR DIA DE LA SEMANA
            let diaValido = false;
            switch (diaSemana) {
                case 1:
                    diaValido = ventanaFija.lun === 1;
                    break;
                case 2:
                    diaValido = ventanaFija.mar === 1;
                    break;
                case 3:
                    diaValido = ventanaFija.mie === 1;
                    break;
                case 4:
                    diaValido = ventanaFija.jue === 1;
                    break;
                case 5:
                    diaValido = ventanaFija.vie === 1;
                    break;
            }
            if (!diaValido && ventanaFija.horaInicio.hours > 0) {
                let error = traducirMessage(47).replace('#####', cliente.nombre).replace('#####', getDiasServiciosVentana());
                //`El cliente ${cliente.nombre} solo cuenta con servicio los días ${getDiasServiciosVentana()}. Favor de seleccionar otra fecha.`;
                enqueueSnackbar(error, { variant: "error" });
            }
        }
        //Valida el horario de la sucursal
          else if (esEntregaHoy && areaServicioRemitente.sucursal.horaCorte) {
             let usuarioZona = moment.tz.guess();
             let sucursalHoraCorte = new Date(actualDate.getFullYear(), Number(actualDate.getMonth()), actualDate.getDate(), areaServicioRemitente.sucursal.horaCorte.hours, areaServicioRemitente.sucursal.horaCorte.minutes);

            //NO CUENTA VENTANA FIJA-FUERA HORA CORTE
            if (selectedDate === actualDate.getDate() && (actualDate.getTime() > sucursalHoraCorte.getTime())) {
                let error = traducirMessage(158).replace('#####', areaServicioRemitente.sucursal.nombre).replace('####', actualDate.getDate() + "/" + Number(actualDate.getMonth() + 1) + "/" + actualDate.getFullYear()).replace('#####', getSucursalHoraCorte(sucursalHoraCorte));
                //`La sucursal ${areaServicioRemitente.sucursal.nombre} no permite la recolección en la fecha ${actualDate.getDate() + "/" + Number(actualDate.getMonth() + 1) + "/" + actualDate.getFullYear()} después de las ${getSucursalHoraCorte(sucursalHoraCorte)}. Favor de seleccionar otra fecha.`
                enqueueSnackbar(error, { variant: "error" });
                return;
            }

            //SIN VENTANA FIJA -FUERA HORARIO RECOLECCION
            if ((selectedDate === actualDate.getDate() && (actualDate.getTime() > sucursalHoraCorte.getTime()))) {
                let hf = new Date(horarios[0]['horaSalida']).toLocaleString('es', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
                let error = traducirMessage(160).replace('#####', areaServicioRemitente.sucursal.nombre).replace('#####', hf);
                //`La sucursal ${areaServicioRemitente.sucursal.nombre} solo permite la recolección hasta las ${hf}. Favor de revisar con el administrador.`;
                enqueueSnackbar(error, {variant: "error"});
                return;
            }

            //NO CUENTA VENTANA FIJA-DIFERENTE ZONA HORARIA
            if (selectedDate === actualDate.getDate() && (zonaHoraria.zona !== usuarioZona) && (actualDate > sucursalHoraCorte)) {
                let error = traducirMessage(158).replace('#####', areaServicioRemitente.sucursal.nombre).replace('#####', actualDate.getDate() + "/" + Number(actualDate.getMonth() + 1) + "/" + actualDate.getFullYear()).replace('#####', getHoraCorte());
                //`La sucursal ${areaServicioRemitente.sucursal.nombre} no permite la recolección en la fecha ${actualDate.getDate() + "/" + Number(actualDate.getMonth() + 1) + "/" + actualDate.getFullYear()} después de las ${getHoraCorte()}. Favor de seleccionar otra fecha.`
                enqueueSnackbar(error, { variant: "error" });
                return;
            }
            if (!validaFrencuenciaArea(diaSemana)) {
                let error = traducirMessage(43).replace('#####', areaServicioRemitente.nombre).replace('#####', getDiasServiciosArea());
                //`El área de servicio ${areaServicioRemitente.nombre} solo cuenta con servicio los días ${getDiasServiciosArea()}. Favor de seleccionar otra fecha.`
                enqueueSnackbar(error, {variant: "error"});
                return;
            }
        }
        //Valida el horario del area de servicio
        else if (horarios.length) {
            let horaEntradaAreaServicio = new Date(actualDate.getFullYear(), Number(actualDate.getMonth() + 1), actualDate.getDate(), new Date(horarios[0]['horaEntrada']).getHours(), new Date(horarios[0]['horaEntrada']).getMinutes());
            let horaSalidaAreaServicio = new Date(actualDate.getFullYear(), Number(actualDate.getMonth() + 1), actualDate.getDate(), new Date(horarios[0]['horaSalida']).getHours(), new Date(horarios[0]['horaSalida']).getMinutes());

            //NO CUENTA VENTANA FIJA-SIN FRENCUENCIA SERVICIO
            if (!validaFrencuenciaArea(diaSemana)) {
                let error = traducirMessage(43).replace('#####', areaServicioRemitente.nombre).replace('#####', getDiasServiciosArea());
                //`El área de servicio ${areaServicioRemitente.nombre} solo cuenta con servicio los días ${getDiasServiciosArea()}. Favor de seleccionar otra fecha.`
                enqueueSnackbar(error, { variant: "error" });
                return;
            }

            //NO CUENTA VENTANA FIJA-EXCEDIO HORARIO DEL AREA DE SERVICIO
            if (selectedDate === actualDate.getDate() && (actualDate > horaSalidaAreaServicio || actualDate < horaEntradaAreaServicio)) {
                let hi = new Date(horaEntradaAreaServicio).toLocaleString('es', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
                let hf = new Date(horaSalidaAreaServicio).toLocaleString('es', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
                let error = traducirMessage(44).replace('#####', areaServicioRemitente.nombre).replace('#####', hi).replace('#####', hf);
                //`El área de servicio ${areaServicioRemitente.nombre} solo permite la recolección entre las ${hi} - ${hf}. Favor de revisar con el administrador.`
                enqueueSnackbar(error, {variant: "error"});
                return;
            }
        }

        // if(aplicaReglasVentana)
        // {
        //     let day = new Date(date).getDay();
        //     if ((day === 1 && ventanaFijaParam.lun === 0)
        //         || (day === 2 && ventanaFijaParam.mar === 0)
        //         || (day === 3 && ventanaFijaParam.mie === 0)
        //         || (day === 4 && ventanaFijaParam.jue === 0)
        //         || (day === 5 && ventanaFijaParam.vie === 0)
        //         || (day === 6 && ventanaFijaParam.sab === 0)
        //         || (day === 0 && ventanaFijaParam.dom === 0)
        //     ) {
        //         let message ="";
        //         if(localStorage.getItem("idioma") === 'en-US')
        //             message = traducirMessage(300) + ventanaFijaParam.ventanaIng;
        //         else
        //             message = traducirMessage(300) + ventanaFijaParam.ventanaEsp;
        //         enqueueSnackbar(message, // "Fecha no válida.",
        //             {variant: "error"});
        //         return false;
        //     }
        // }

        ///SUCURSAL SIN ZONA HORARIA
        if (!zonaHoraria['zona']) {
            let error = traducirMessage(157).replace('#####', areaServicioRemitente.sucursal.nombre);
            //`La sucursal ${areaServicioRemitente.sucursal.nombre} no cuenta con una zona horaria configurada.`;
            enqueueSnackbar(error, { variant: "error" });
            return;
        }
        setDisabledGuardar(false);
        setSelectedDate(date);
    };

    const getHoraCorte = () => {
        return `${new Date(areaServicioRemitente.sucursal.horaCorte.hours).toLocaleString('es', { hour: 'numeric', hour12: false })}:${new Date(areaServicioRemitente.sucursal.horaCorte.minutes).toLocaleString('es', { minute: '2-digit', hour12: false })}`;
    }


    const getSucursalHoraCorte = (date) => {
        return `${new Date(date).toLocaleString('es', { hour: 'numeric', minute: '2-digit', hour12: false })}`;
    }

    const validaFrencuenciaArea = (dia) => {
        let valido = false;
        if (horarios.length && horarios[0].dias) {
            valido = horarios[0].dias.filter(s => s.id === dia).length === 1;
            if(!valido && horarios.length>1)
            {
                valido = horarios[1].dias.filter(s => s.id === dia).length === 1;
            }
        }
        if(dia === 0){
            valido = false;
        }
        return valido;
    }

    const getDiasServiciosVentana = () => {
        let dias = "";
        if (ventanaFija != null) {
            if(localStorage.getItem("idioma") === 'en-US'){
                dias += ventanaFija.lun === 1 ? "Monday " : " ";
                dias += ventanaFija.mar === 1 ? "Tuesday " : " ";
                dias += ventanaFija.mie === 1 ? "Wednesday " : " ";
                dias += ventanaFija.jue === 1 ? "Thursday " : " ";
                dias += ventanaFija.vie === 1 ? "Friday" : " ";
            }
            else{
                dias += ventanaFija.lun === 1 ? "Lunes " : " ";
                dias += ventanaFija.mar === 1 ? "Martes " : " ";
                dias += ventanaFija.mie === 1 ? "Miércoles " : " ";
                dias += ventanaFija.jue === 1 ? "Jueves " : " ";
                dias += ventanaFija.vie === 1 ? "Viernes" : " ";
            }

        }
        return dias;
    }

    const getDiasServiciosArea = (): string => {
        let dias: string[] = [];

        areaServicioRemitente.horarios?.forEach(h => {
            h.dias.forEach(d => {
                dias.push(d.nombre);
            })
        })

        return dias.join(", ");
    }

    const saveDate = () => {
        //let date = !selectedDate ? defaultDate.format('YYYY-MM-DD') : selectedDate;
        let date = !selectedDate ? defaultDate : selectedDate;
        //const defaultDate = value ? new Date(value) : new Date();
        onSave(new Date(date));
        setOpen(false);
    };

    const [open, setOpen] = useState(false);
    const openHelp = () => {
        setOpen(true);
    };

    const closeHelp = () => {
        setOpen(false);
        onClose();
    };

    const getZonaHoraria = async () => {
        const result = await apiSource.obtenerAsync<any>("solicitud-servicio/get-zona-horaria/" + areaServicioRemitente?.sucursal?.id,{username: localStorage.getItem("usuario_nombre")});
        return result;
    };

    const getZonaHorariaServer = async () => {
        const result = await apiSource.obtenerAsync<string>("hora-actual/actual-date");
        return result;
    };

    const getDiasFestivos = async () => {
        const result = await apiSource.postAsync<any>("solicitud-servicio/obtener-dias-festivos",{username: localStorage.getItem("usuario_nombre")});
        return result;
    };

    const getDiasInhabilProximos = async () => {
        const result = await apiSource.postAsync<any>("solicitud-servicio/dias-inhabil-proximos",{username: localStorage.getItem("usuario_nombre")});
        return result;
    };

    const getVentanaFija = async () => {
        const result = await apiSource.obtenerAsync<any>("solicitud-servicio/get-ventana-fija?clienteId=" + cliente.id + "&sucursalId=" + areaServicioRemitente?.sucursal?.id+ "&username=" +  localStorage.getItem("usuario_nombre"));
        return result;
    };

    const obtenerDiasDeshabilitados =()=>{
        let disabledDays:number [] = [];
        disabledDays.push(0);
        if(aplicaReglasVentana)
        {
            if(ventanaFijaParam.lun===0)
                disabledDays.push(1);
            if(ventanaFijaParam.mar===0)
                disabledDays.push(2);
            if(ventanaFijaParam.mie===0)
                disabledDays.push(3);
            if(ventanaFijaParam.jue===0)
                disabledDays.push(4);
            if(ventanaFijaParam.vie===0)
                disabledDays.push(5);

        }

        return disabledDays;
    }

    const modifiers = {
        "specific-disabled": [...arrayDiasFestivos]
      };

      const disabledStyle = `.DayPicker-Day--specific-disabled {
        color: #DCE0E0;
        cursor: default;
        pointer-events: none;
      }`;

    return (<>
        <div style={{ position: "relative", width: "100%", textAlign: "left" }}>
            <Tooltip title={traducirMessage(245)} aria-label="fecha">
                <IconButton color="primary" aria-label="fecha" style={{ position: "absolute", top: "-25px", right: "-33px", color: !value ? "#00653b" : "white" }}
                    onClick={openHelp}>
                    <EventAvailableIcon />
                </IconButton>
            </Tooltip>
        </div>
        <Dialog open={open} maxWidth="sm" fullWidth={true} onClose={closeHelp}>
            <DialogTitle id="simple-dialog-title">
                {/* Fecha de Recolección */
                    traducirLabel(130)
                }
            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText>
                {localStorage.getItem("idioma") === 'en-US' &&
                    <div>
                        <style>{disabledStyle}</style>
                        <DayPicker
                            locale={'en'}
                            modifiers={modifiers}
                            months={MONTHS['us']}
                            weekdaysShort={WEEKDAYS_SHORT['us']}
                            selectedDays={new Date(selectedDate)}
                            onDayClick={handleDateChange}
                            disabledDays={[
                                { before: new Date() },
                                { daysOfWeek: obtenerDiasDeshabilitados() },
                                { after: new Date(Date.now()+daysRad*24*60*60*1000) }
                            ]}
                        />
                    </div>
                }
                {localStorage.getItem("idioma") !== 'en-US' &&
                    <div>
                        <style>{disabledStyle}</style>
                        <DayPicker
                            locale={'es'}
                            modifiers={modifiers}
                            months={MONTHS['es']}
                            weekdaysShort={WEEKDAYS_SHORT['es']}
                            selectedDays={new Date(selectedDate)}
                            onDayClick={handleDateChange}
                            disabledDays={[
                                { before: new Date() },
                                { daysOfWeek: obtenerDiasDeshabilitados() },
                                { after: new Date(Date.now()+daysRad*24*60*60*1000) }
                            ]}
                        />
                    </div>

                }
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={saveDate} variant="contained" color="primary" disabled={disabledGuardar}>
                    {/* Guardar */
                        traducirButton(12)}
                </Button>
                <Button onClick={closeHelp} variant="contained">
                    {/* Cerrar */
                        traducirButton(16)}
                </Button>
            </DialogActions>
        </Dialog>
        {
            showLoading &&
            <>
                <LoadingDialog titulo={traducirLabel(240)/* Procesando */} abierto={true} />
            </>
        }
    </>)
};
const mapStateToProps = (state: ApplicationState) => ({
    diasFestivos: state.diasFestivos
});
export default connect(mapStateToProps)(PickUpDateRecoleccion);
